module.exports = __webpack_public_path__ + "public/img/system.bb6a7687.png";